module.exports = __webpack_public_path__ + "img/nav-home.6ba45895.svg";